import { Controller } from '@hotwired/stimulus'

export class WelcomeVideoController extends Controller {
    declare readonly placeholderTarget: HTMLDivElement;
    static targets = ['placeholder']

    play() {
        const template = this.element.querySelector("#ovasai-video-template");
        if(template instanceof HTMLTemplateElement) {
            const clone = template.content.cloneNode(true);
            this.placeholderTarget.replaceChildren(clone);
        }
    }
}